/*
 * rx-total.js
 * -----------
 * Live-updating "Your Total" row for Rx PDPs.
 *
 * Horizon dispatches `variant:update` on document whenever the product form
 * receives a new variant. We listen, re-format the price using the shop's
 * money_format template, and swap the text content of [data-rx-total]
 * (and the optional "+$X in upgrades" delta).
 *
 * We deliberately avoid importing @theme/money-formatting — this file is a
 * plain <script src>. We re-implement just the amount/currency placeholder
 * branches of Shopify's money filter, which is enough for USD, EUR, JPY, etc.
 */
(function () {
  'use strict';

  var CURRENCY_DECIMALS = {
    JPY: 0,
    KRW: 0,
    CLP: 0,
    VND: 0,
    ISK: 0,
    HUF: 0,
    TWD: 0,
    BIF: 0,
    DJF: 0,
    GNF: 0,
    KMF: 0,
    MGA: 0,
    PYG: 0,
    RWF: 0,
    UGX: 0,
    UYI: 0,
    VUV: 0,
    XAF: 0,
    XOF: 0,
    XPF: 0
  };

  function getPrecision(currency) {
    var c = (currency || 'USD').toUpperCase();
    if (CURRENCY_DECIMALS[c] !== undefined) return CURRENCY_DECIMALS[c];
    return 2;
  }

  function formatAmount(cents, precision, thousandsSeparator, decimalSeparator) {
    var divisor = Math.pow(10, precision);
    var value = (Math.abs(cents) / divisor).toFixed(precision);
    var parts = value.split('.');
    var intPart = parts[0];
    var fracPart = parts[1] || '';
    intPart = intPart.replace(/\d(?=(\d\d\d)+(?!\d))/g, function (digit) {
      return digit + thousandsSeparator;
    });
    return precision <= 0 ? intPart : intPart + decimalSeparator + fracPart.padEnd(precision, '0');
  }

  function formatMoney(cents, format, currency) {
    if (cents == null || isNaN(cents)) return '';
    format = format || '${{amount}}';
    var precision = getPrecision(currency);

    return format.replace(/{{\s*(\w+)\s*}}/g, function (_, placeholder) {
      if (placeholder === 'currency') return currency;
      var thousandsSeparator = ',';
      var decimalSeparator = '.';
      var p = precision;
      switch (placeholder) {
        case 'amount':
          break;
        case 'amount_no_decimals':
          p = 0; break;
        case 'amount_with_comma_separator':
          thousandsSeparator = '.'; decimalSeparator = ','; break;
        case 'amount_no_decimals_with_comma_separator':
          thousandsSeparator = '.'; p = 0; break;
        case 'amount_no_decimals_with_space_separator':
          thousandsSeparator = ' '; p = 0; break;
        case 'amount_with_space_separator':
          thousandsSeparator = ' '; break;
        case 'amount_with_apostrophe_separator':
          thousandsSeparator = "'"; break;
        default:
          return '';
      }
      return formatAmount(cents, p, thousandsSeparator, decimalSeparator);
    });
  }

  function formatMoneyNoTrailingZeros(cents, format, currency) {
    var formatted = formatMoney(cents, format, currency);
    // Strip .00 (or ,00) if the fractional part is all zeros
    return formatted.replace(/([.,])0+(?=\D|$)/g, '');
  }

  function updateContainer(container, newPrice) {
    if (!container) return;
    var format = container.getAttribute('data-money-format') || '${{amount}}';
    var currency = container.getAttribute('data-currency') || 'USD';
    var basePrice = parseInt(container.getAttribute('data-base-price') || '0', 10);

    var totalEl = container.querySelector('[data-rx-total]');
    if (totalEl) {
      totalEl.textContent = formatMoney(newPrice, format, currency);
    }

    var deltaEl = container.querySelector('[data-rx-delta]');
    if (deltaEl) {
      var deltaAmountEl = deltaEl.querySelector('[data-rx-delta-amount]');
      var delta = newPrice - basePrice;
      if (delta > 0) {
        if (deltaAmountEl) {
          deltaAmountEl.textContent = formatMoneyNoTrailingZeros(delta, format, currency);
        }
        deltaEl.hidden = false;
      } else {
        deltaEl.hidden = true;
      }
    }
  }

  function handleVariantUpdate(event) {
    if (!event || !event.detail) return;
    // Horizon's VariantUpdateEvent stores the variant at event.detail.resource
    var variant = event.detail.resource;
    if (!variant || typeof variant.price !== 'number') return;

    var containers = document.querySelectorAll('[data-rx-price-total]');
    for (var i = 0; i < containers.length; i++) {
      updateContainer(containers[i], variant.price);
    }
  }

  // Horizon uses 'variant:update' for post-swap variant data
  document.addEventListener('variant:update', handleVariantUpdate);

  // Also listen for the earlier 'variant:selected' event in case consumers
  // need an immediate optimistic update — it doesn't carry a price, so we
  // skip unless someone later extends the payload.
  // document.addEventListener('variant:selected', handleVariantUpdate);
})();
